var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dropdown-item"},[(_vm.item.image)?_c('img',{attrs:{"src":_vm.item.image}}):_vm._e(),_c('div',[_c('label',{staticStyle:{"font-weight":"bold"}},[_vm._v(_vm._s(_vm.item.title))]),(_vm.item.subTitle)?_c('div',[_vm._v(_vm._s(_vm.item.subTitle))]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }